import React, { useState, useEffect } from "react";
import "./Managecountry.css";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import {
  createCountry,
  getCountryList,
  updateCountryStatus,
  updateCountry,
  fetchCountryDropdown,
  exportCountryList,
} from "../../../API Service/apiService";
import {
  Autocomplete,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CommonButton from "../../../Componants/Common/Button";
import Paginate from "../../../Componants/Common/Paginate";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import Subheader from "../../../Componants/Common/Subheader";
import config from "../../../Componants/Common/config";
import toast, { Toaster } from "react-hot-toast";
import { library } from "@fortawesome/fontawesome-svg-core";
import Loader from "../../../Componants/Common/Loader";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Constants } from "./../../../constants/Constants";
import FileSaver from "file-saver";

const countryHeaders = [
  { label: "S. No.", key: "serialNumber" },
  { label: "Country", key: "countryName" },
];

const Managecountry = ({ isSidebarCollapsed }) => {
  const [sidebarClass, setSidebarClass] = useState(
    isSidebarCollapsed ? "collapsed" : "expanded"
  );

  useEffect(() => {
    setSidebarClass(isSidebarCollapsed ? "collapsed" : "expanded");
  }, [isSidebarCollapsed]);
  const [page, setPage] = useState(1);
  const pageSize = config.pageSize;
  const dummyGetList = {
    serialNo: "",
    countryName: "",
    page: page,
    limit: pageSize,
  };
  const [value, setValue] = React.useState([]);
  const [countries, setCountries] = useState([]);
  const [editIndex, setEditIndex] = useState(false);
  const [loading, setLoading] = useState(false);

  const [postData, setPostData] = useState({
    countryName: "",
    countryCode: "",
  });

  const [selectedCountry, setSelectedCountry] = useState(null); // State to hold the selected country
  const [filteredCountries, setFilteredCountries] = useState(countries);
  const [countryDropdown, setCountryDropdown] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalItems = filteredCountries.length;

  const startIndex = (currentPage - 1) * itemsPerPage;

  const [dataSize, setDataSize] = useState(pageSize);
  const [searchParams, setSearchParams] = useState({
    search: "",
    status: "",
    page: 1,
    limit: 10,
  });

  const [totalRecords, setTotalRecords] = useState(1);
  const [countryId, setcountryId] = useState("");

  const handlePageChange = (newPage) => {
    if (newPage < 1) return;
    if (newPage > Math.ceil(totalRecords / pageSize)) return;
    
    setPage(newPage);
    setSearchParams((prevParams) => ({
      ...prevParams,
      page: newPage.toString(),
    }));
  };

  const handleSearch = async () => {
    setPage(1);
    setSearchParams((prevParams) => ({
      ...prevParams,
      page: 1,
    }));
    await fetchCountries(searchParams);
  };

  const handleCancel = async () => {
    setPage(1);
    const updatedParams = {
      ...searchParams,
      page: 1,
      search: "",
    };
    setSearchParams(updatedParams);
    await fetchCountries(updatedParams);
  };
  useEffect(() => {
    fetchCountries();
  }, [page]);

  const fetchCountries = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await getCountryList(params);
      setCountries(response.data.countries);
      console.log("response.data", response.data);
      setFilteredCountries(response.data.countries);
      setTotalRecords(response.data.totalCountries);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoading(false);
    }
  };

  const getCountryDropdown = async () => {
    try {
      const response = await fetchCountryDropdown();
      if (response.status == "success") {
        setCountryDropdown(response.data);
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };
  const handleEdit = (index) => {
    const countryToEdit = filteredCountries[index];
    console.log("countryToEdit", countryToEdit);
    setcountryId(countryToEdit._id);
    setPostData((p) => ({
      ...p,
      countryCode: countryToEdit.countryCode,
      countryName: countryToEdit.countryName,
      Status: countryToEdit.active,
    }));
    formik.setValues({
      countryName: countryToEdit.countryName,
    });
    setEditIndex(true);
  };

  const handleStatus = async (index, countryId) => {
    try {
      setLoading(true);
      const response = await updateCountryStatus({ countryId: countryId });
      console.log(`status resposne : ${response.status}`);

      if (response.status === "success") {
        toast.success("Status Updated Successfully");
        await Promise.all([
          fetchCountries(),
          getCountryDropdown()
        ]);
      }
    } catch (error) {
      console.log(`Error updating status ${error}`);
      toast.error(`Failed to update status`);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const startingSerialNumber = (page - 1) * pageSize + 1;

  const validationSchema = Yup.object({
    countryName: Yup.string()
      .required("Country name is required")
      .min(2, "Country name must be at least 2 characters")
      .max(50, "Country name must be at most 50 characters")
      .matches(
        /^[A-Za-z ]*$/,
        "Only alphabetic characters and spaces are allowed"
      ),
  });

  // Update the formik configuration section
  const formik = useFormik({
    initialValues: {
      countryName: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setPostData({
        countryName: values.countryName,
        countryCode: values.countryName,
      });
      try {
        setLoading(true);
        if (editIndex === true) {
          const editBody = {
            countryId,
            countryName: values.countryName,
            countryCode: values.countryName,
          };
          const response = await updateCountry(editBody);
          if (response.status === "success") {
            toast.success(response.message);
            await Promise.all([
              fetchCountries(),
              getCountryDropdown()
            ]);
            formik.resetForm();
            setEditIndex(false);
          }
        } else {
          const response = await createCountry({
            countryName: values.countryName,
            countryCode: values.countryName,
          });
          if (response.status === "success") {
            toast.success(response.message);
            await Promise.all([
              fetchCountries(),
              getCountryDropdown()
            ]);
            formik.resetForm();
          }
        }
        setPostData({
          countryName: "",
          countryCode: "",
        });
        setEditIndex(false);
      } catch (error) {
        toast.error(`Message: ${error.response.data.message}`);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleExportToExcel = async () => {
    try {
      setLoading(true);
      const response = await exportCountryList();

      if (response) {
        // Create blob from response data
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, "counties.xlsx");
        toast.success("File downloaded successfully");
      } else {
        throw new Error("No data received for export.");
      }
    } catch (error) {
      console.error("Error exporting country list:", error);
      toast.error(` ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCountryDropdown();
  }, []);
  return (
    <div className={`managecountry-container ${sidebarClass}`}>
      <Toaster />
      {loading && <Loader />}
      <HeaderNavigation value={"Location > Country"}  location={"/setting"}/>

      <div className="autocompleteform-managecountry">
        <div className="line-managecountry">
          <div className="textinput-managecountry">
            <div className="textinput2-managecountry">
              <Subheader heading={"Add Country"} />
            </div>

            <TextField
              style={{ width: "100%" }}
              id="countryName"
              label="Country"
              variant="standard"
              value={formik.values.countryName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.countryName && Boolean(formik.errors.countryName)
              }
              helperText={
                formik.touched.countryName && formik.errors.countryName
              }
              InputLabelProps={{
                required: true,
              }}
            />
          </div>
        </div>

        <div className="button-managecountry">
          <span className="buttons-managecountry-span">
            <CommonButton
              name={editIndex == true ? Constants.update : Constants.create}
              handleOnClick={formik.handleSubmit}
              disabled={loading}
            />
          </span>
          <span className="buttons-managecountry-span">
            <CommonButton
              name={"CANCEL"}
              handleOnClick={() => {
                formik.resetForm();
                setPostData({ countryCode: "", countryName: "", Status: "" });
                setEditIndex(false);
              }}
            />
          </span>
        </div>
      </div>

      <div className="autocompleteform-managecountry">
        <div className="line-managecountry">
          <div className="textinput2-managecountry">
            <Subheader heading={"List View"} />
          </div>
        </div>

        <div className="line-managecountry">
          <div className="textinput-managecountry">
            <Autocomplete
              id="country-autocomplete"
              options={countryDropdown}
              getOptionLabel={(option) => option.countryName}
              value={countryDropdown.find(
                (country) => country.countryName === searchParams.search
              ) || null}
              onChange={(e, newValue) => {
                setSearchParams((prevParams) => ({
                  ...prevParams,
                  search: newValue ? newValue.countryName : "",
                }));
              }}
              clearOnBlur
              blurOnSelect
              renderInput={(params) => (
                <TextField {...params} label="Country" variant="standard" />
              )}
            />
          </div>

          <div className="textinput-managecountry">
            <CommonButton
              name={Constants.search}
              handleOnClick={handleSearch}
            />
          </div>
          <div className="textinput-managecountry">
            <CommonButton
              name={Constants.cancel}
              handleOnClick={handleCancel}
            />
          </div>
          <div className="textinput-managecountry"></div>
          <div className="textinput-managecountry"></div>
        </div>

        <div className="table-managecountry">
          <div className="excelexport-Managecity">
            <span className="buttons-Managecity-span">
              <ExportToExcel onClick={handleExportToExcel} />
            </span>
          </div>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#fff" }} align="left">
                    S. No.
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }} align="center">
                    Country
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }} align="right">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredCountries.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No Data Available
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredCountries.map((country, index) => (
                    <TableRow
                      key={country.id}
                      // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="left">
                        {startingSerialNumber + index}{" "}
                      </TableCell>
                      <TableCell align="center">{country.countryName}</TableCell>

                      <TableCell
                        align="right"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                        }}
                      >
                        <IconButton
                          onClick={() => handleStatus(index, country._id)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={
                              country.active === false ? inactiveIcon : activeIcon
                            }
                            alt="active"
                            height={"20px"}
                            width={"20px"}
                          />
                        </IconButton>

                        <IconButton
                          onClick={() => handleEdit(index)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={editIcon}
                            alt="Edit"
                            height={"20px"}
                            width={"20px"}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="pagination-container">
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
          />
        </div>
      </div>
    </div>
  );
};

export default Managecountry;
